// @flow
import React, { Component } from 'react';
import { compose } from 'redux';
import { type CategoryData } from 'store/modules/common';
import { type ContextRouter, withRouter, type Location } from 'react-router-dom';
import './MainMobileHead.scss';
import MainMobileHeadItem from '../MainMobileHeadItem';

type Props = {
  location: Location,
  categories: ?(CategoryData[]),
} & ContextRouter;

type State = {
  isMouseOverMenu: boolean,
  inkBarStyle: {
    left: number,
    width: number,
  },
};

class MainMobileHead extends Component<Props, State> {
  state = {
    isMouseOverMenu: false,
    inkBarStyle: {
      left: 0,
      width: 0,
    },
  };

  itemsRef = React.createRef();
  itemRefs = [];

  handleMouseOverMenu = () => {
    this.setState({ isMouseOverMenu: true });
  };

  handleMouseLeaveMenu = () => {
    this.setState({ isMouseOverMenu: false });
  };

  componentDidMount() {
    this.updateInkBar();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.updateInkBar();
    }
  }

  updateInkBar = () => {
    const activeIndex = this.getActiveIndex();
    if (activeIndex !== -1 && this.itemRefs[activeIndex]) {
      const activeItem = this.itemRefs[activeIndex];
      const container = this.itemsRef.current;
      if (activeItem && container) {
        const containerRect = container.getBoundingClientRect();
        const itemRect = activeItem.getBoundingClientRect();
        this.setState({
          inkBarStyle: {
            left: itemRect.left - containerRect.left,
            width: itemRect.width,
          },
        });
      }
    }
  };

  getActiveIndex = () => {
    const { location } = this.props;
    const url = location.pathname;

    if (url === '/') return 0;
    if (/^\/categories/.test(url) || /^\/@.*\/products\/.*/.test(url)) return 1;
    if (/^\/posts/.test(url) || /^\/@.*\/posts\/.*/.test(url) || /^\/@.*\/blog-.*/.test(url)) return 2;
    if (/^\/brands/.test(url) || /^\/products\/tags\/.*/.test(url)) return 3;
    if (/^\/events/.test(url) || /^\/@.*\/events\/.*/.test(url)) return 4;
    if (/^\/sections\/discount/.test(url)) return 5;
    
    return -1;
  };

  render() {
    const { location, categories, history } = this.props;
    const url = location.pathname;

    // 각 헤드 메뉴 url 체크하는 부분 변수화
    const isHomeActive = url === '/';
    const isCategoriesActive = /^\/categories/.test(url) || /^\/@.*\/products\/.*/.test(url);
    const isBrandsActive = /^\/brands/.test(url) || /^\/products\/tags\/.*/.test(url);
    const isEventsActive = /^\/events/.test(url) || /^\/@.*\/events\/.*/.test(url);
    const isFamousActive = /^\/sections\/discount/.test(url);
    const isEstimateActive = /^\/estimate/.test(url) || /^\/@.*\/estimate\/.*/.test(url);

    // 블로그 메뉴 활성화 조건:
    // 1. /posts로 시작하는 URL
    // 2. /@사용자명/posts/ 형식의 URL
    // 3. /@사용자명/blog- 형식의 URL
    // 4. 다른 메뉴가 활성화되지 않았고, /@사용자명/ 형식의 URL인 경우
    const isPostsActive =
      /^\/posts/.test(url) ||
      /^\/@.*\/posts\/.*/.test(url) ||
      /^\/@.*\/blog-.*/.test(url) ||
      (/^\/@.*\/.+/.test(url) &&
        !isHomeActive &&
        !isCategoriesActive &&
        !isBrandsActive &&
        !isEventsActive &&
        !isFamousActive &&
        !isEstimateActive);

    return (
      <div className="MainMobileHead">
        <ul className="items" ref={this.itemsRef}>
          <MainMobileHeadItem 
            active={isHomeActive} 
            to="/" 
            name="쇼핑홈" 
            itemRef={(el) => { this.itemRefs[0] = el; }}
          />
          <MainMobileHeadItem
            isMouseOver={this.state.isMouseOverMenu}
            handleMouseLeave={this.handleMouseLeaveMenu}
            handleMouseOver={this.handleMouseOverMenu}
            categories={categories}
            history={history}
            active={isCategoriesActive}
            to="/categories"
            name="카테고리"
            itemRef={(el) => { this.itemRefs[1] = el; }}
          />
          <MainMobileHeadItem 
            active={isPostsActive} 
            to="/posts" 
            name="블로그" 
            itemRef={(el) => { this.itemRefs[2] = el; }}
          />
          <MainMobileHeadItem 
            active={isBrandsActive} 
            to="/brands" 
            name="브랜드" 
            itemRef={(el) => { this.itemRefs[3] = el; }}
          />
          <MainMobileHeadItem 
            active={isEventsActive} 
            to="/events" 
            name="이벤트" 
            itemRef={(el) => { this.itemRefs[4] = el; }}
          />
          <MainMobileHeadItem 
            active={isFamousActive} 
            to="/sections/discount" 
            name="특별할인" 
            itemRef={(el) => { this.itemRefs[5] = el; }}
          />
          <div 
            className="ink-bar" 
            style={{
              left: `${this.state.inkBarStyle.left}px`,
              width: `${this.state.inkBarStyle.width}px`,
            }}
          />
        </ul>
      </div>
    );
  }
}

// export default compose(withRouter)(MainMobileHead);
export default withRouter(MainMobileHead);



// WEBPACK FOOTER //
// ./src/components/main/MainMobileHead/MainMobileHead.js